import { render } from "./SelectGlobalEvent.vue?vue&type=template&id=cf89a97a&ts=true"
import script from "./SelectGlobalEvent.vue?vue&type=script&lang=ts"
export * from "./SelectGlobalEvent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__